import $ from 'jquery';
import 'jquery-match-height';

const selectors = {
    container: '.js-equal-article-height',
    articles: '[data-mh="article-text"]'
};

/** 
 * make articles same height.
 **/
export default class EqualArticleHeight {
    constructor() {
		$(selectors.articles).matchHeight({
			byRow: true,
			property: 'height'
		});
    }
}

/*
 * search for all js-equal-article-height classes in the project and apply this module.
 */
$(selectors.container).each(function () {
    new EqualArticleHeight();
});